import styled from 'styled-components';
import { devices } from '@styles/global';

export const StyledContainer = styled.div<{
  'data-sidebar-collapsed'?: boolean;
  'data-mobile-menu-open'?: boolean;
}>`
  min-height: calc(100vh - var(--app-topbar-height));
  height: auto;
  margin-top: var(--app-topbar-height);
  margin-left: ${props =>
    props['data-sidebar-collapsed']
      ? 'var(--app-sidebar-collapsed-width)'
      : 'var(--app-sidebar-open-width)'};
  background-color: ${(props) => props.theme['page-bg']};
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-x: hidden;
  overflow-y: visible;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @supports (min-height: 100dvh) {
    min-height: calc(100dvh - var(--app-topbar-height));
  }

  @media (max-width: ${devices.tablet}) {
    margin-top: 56px;
    min-height: calc(100vh - 56px);
    margin-left: 0;

    @supports (min-height: 100dvh) {
      min-height: calc(100dvh - 56px);
    }
  }
`;

export const StyledBody = styled.main`
  flex: 1 1 auto;
  min-height: calc(100vh - var(--app-topbar-height));
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  display: flex;
  justify-content: center;
  padding: var(--app-shell-padding);

  > * {
    max-width: var(--app-container-max-width);
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme['gray-100']};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme['gray-300']};
    border-radius: 4px;

    &:hover {
      background: ${(props) => props.theme['gray-400']};
    }
  }

  @media (max-width: ${devices.tablet}) {
    min-height: calc(100vh - 56px);
    padding: var(--app-shell-padding);
  }

  @media (max-width: ${devices.mobileL}) {
    padding: 12px;
  }
`;
